import { FC, memo } from 'react';

import { CheckDuplicate } from './CheckDuplicates';
import { useRequestDuplicatesNetSuiteBill } from './CheckDuplicates.hooks';
import { CheckDuplicateEntityProps } from './CheckDuplicates.types';

/**
 * @deprecated use {@link CheckDuplicatesPopup}
 */
export const CheckDuplicatesNetSuite: FC<CheckDuplicateEntityProps> = memo((props) => {
    const duplicateData = useRequestDuplicatesNetSuiteBill();

    return <CheckDuplicate {...props} duplicateData={duplicateData} />;
});

CheckDuplicatesNetSuite.displayName = 'CheckDuplicatesNetSuite';
